export default __webpack_public_path__ + "move24.svg";